// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function sencillitoValidator(): ?UserInputValidationError {
  return VALID;
}
